import { Api } from '@/api/api.client';
import type { Components } from '@/api/generated/api';

export async function fetchGradeCalculationSettings(): Promise<Components.Schemas.GradeCalculationSettingsWithTagsDto> {
  const result = await Api.Routes.GradeCalculationSettings.getSettings();
  return result.data;
}

export async function updateGradeCalculationSettings(
  dto: Components.Schemas.UpdateGradeCalculationSettingsDto,
): Promise<void> {
  await Api.Routes.GradeCalculationSettings.updateSettings(null, dto);
}
